import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, ActivatedRoute, Routes } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { routes } from './app-routing.module';

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;
    languagesAvailable = ["tr", "en"];
    langSelected = null;
    currentLang: string;
    routesConfig: { [key: string]: { tr: string; en: string } } = {};

    constructor(private router: Router,
        private titleService: Title,
        private metaService: Meta
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateMetaTags();
        });

    }

    updateMetaTags() {
        let currentRoute = this.router.routerState.root;
        let componentName = '';
        let data;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            componentName = currentRoute.snapshot.component?.name;
            data = currentRoute.snapshot.data;
        }

        if (data) {
            if (data.title) {
                this.titleService.setTitle(data.title);
            }

            if (data.description) {
                this.metaService.updateTag({ name: 'description', content: data.description });
            }

            if (data.robots) {
                this.metaService.updateTag({ name: 'robots', content: data.robots });
            }

            // Open Graph meta tags
            this.addOpenGraphTags(data.title, data.description);

            // Twitter Card meta tags
            this.addTwitterTags(data.title, data.description);

            this.addCanonicalUrl();

            this.addHreflangTags(componentName);


        }
    }

    addCanonicalUrl() {
        const link: HTMLLinkElement = document.querySelector("link[rel='canonical']") || document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', window.location.href);
        document.head.appendChild(link);
    }


    addHreflangTags(componentName: string) {
        const baseUrl = 'https://www.dotcrea.com';
        const hreflangTags = [];

        const findUrlsByComponent = (componentName: string, routeConfig: Routes, langPrefix: string) => {
            routeConfig.forEach(route => {
                if (route.children) {
                    // For root path (Turkish), don't add extra slash
                    const prefix = route.path === '' ? langPrefix : langPrefix + route.path + '/';
                    findUrlsByComponent(componentName, route.children, prefix);
                } else if (route.component && route.component?.name === componentName) {
                    // Determine language based on path
                    const isEnglish = langPrefix.includes('en');
                    const lang = isEnglish ? 'en' : 'tr';

                    // Build URL - remove double slashes and trailing slashes
                    let url = `${baseUrl}/${langPrefix}${route.path}`;
                    url = url.replace(/\/+/g, '/').replace(/\/$/, '');

                    hreflangTags.push({
                        lang: lang,
                        url: url
                    });
                }
            });
        };

        findUrlsByComponent(componentName, routes, '');

        // Eski hreflang linklerini temizle
        const existingHreflangLinks = document.querySelectorAll("link[rel='alternate'][hreflang]");
        existingHreflangLinks.forEach(link => {
            link.parentNode.removeChild(link);
        });

        // Yeni hreflang etiketlerini ekle
        hreflangTags.forEach(tag => {
            const linkElement = document.createElement('link');
            linkElement.setAttribute('rel', 'alternate');
            linkElement.setAttribute('hreflang', tag.lang);
            linkElement.setAttribute('href', tag.url);
            document.head.appendChild(linkElement);
        });
    }

    addOpenGraphTags(title: string, description: string) {
        const url = window.location.href;
        const imageUrl = 'https://www.dotcrea.com/assets/img/dotcrea.com.png'; // Görsel URL'sini gerektiği gibi düzenleyin

        this.metaService.updateTag({ property: 'og:title', content: title });
        this.metaService.updateTag({ property: 'og:description', content: description });
        this.metaService.updateTag({ property: 'og:url', content: url });
        this.metaService.updateTag({ property: 'og:image', content: imageUrl });
    }

    addTwitterTags(title: string, description: string) {
        const imageUrl = 'https://www.dotcrea.com/assets/img/dotcrea.com.png'; // Görsel URL'sini gerektiği gibi düzenleyin

        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this.metaService.updateTag({ name: 'twitter:title', content: title });
        this.metaService.updateTag({ name: 'twitter:description', content: description });
        this.metaService.updateTag({ name: 'twitter:image', content: imageUrl });
    }


    ngOnInit() {
        //this.recallJsFuntions();
    }

    // recallJsFuntions() {
    //     this.router.events
    //         .subscribe((event) => {
    //             if (event instanceof NavigationStart) {
    //                 $('.preloader').fadeIn('slow');
    //             }
    //         });
    //     this.routerSubscription = this.router.events
    //         .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
    //         .subscribe(event => {
    //             //$.getScript('../assets/js/main.js');
    //             $('.preloader').fadeOut('slow');
    //             this.location = this.router.url;
    //             if (!(event instanceof NavigationEnd)) {
    //                 return;
    //             }
    //             window.scrollTo(0, 0);
    //         });
    // }
}